<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-7 h-col-inputBox">
          <div class='h-inputLit'>
            <span>{{$t('MCS.userNum')}}</span>
          </div>
          <input class="e-input" :value='userNum' disabled="true"/>
      </div>
    </div>
    <br>
    <div class="h-borderBox">
      <div class="h-dialog-borderBox-topIcon">
        <div class="h-toolbarBg dialog-icon-style">
          <ejs-toolbar class="dialog-icon-style">
            <div class="dialog-icon-style" >
              <div>
                <button :title='$t("MCS.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style" data-ripple="true" tabindex="-1" @click='delGroupList'>
                  <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
                </button>
              </div>
            </div>
          </ejs-toolbar>
        </div>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='400px' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' headerText='index' width='25' textAlign='Center'></e-column>
            <e-column field='groupNum' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.groupNum")' width='200' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
    <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialog' ></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import commonJS from '../../common';
import CustomDialog from '../../../../common/CustomDialog'
import DialogList from '../../../util/tipDialog/DialogList';

export default {
  name: 'QryGroupDialog',
  props: [
    'neid'
  ],
  mixins: [commonJS],
  components: {
    CustomDialog,
    DialogList
  },
  data() {
    return {
      data: '',
      userNum: '',
      mcsid: '',
      vo: '',
      page: '',
      dialogTip: {
        target: this.$refs.grouptable,
        refName: 'dialogList',
        buttonGroup: [
          {
            click: this.closeDialogListTipPage,
            buttonModel: { content: this.$t('MCS.cancle') }
          }
        ],
        title: this.$t('MCS.messageInfo'),
        isClose: true,
      },
    };
  },
  methods: {
    getGroupList(page = this.page, vo = this.vo, userNum = this.userNum, mcsid = this.mcsid) {
      const $this = this;
      this.userNum = userNum;
      this.mcsid = mcsid;
      this.page = page;
      this.vo = vo;

      const params = {
        info: {
          neid: this.neid,
          msgid: this.msg.qryGroupList
        },
        vo: vo,
        page: page
      };
      console.log(params);
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        const res = response.data;
        $this.data = res.resultVal;
      });
    },
    delGroupList() {
      if (this.$refs.grid.getSelectedRecords().length === 0) {
        this.$toast('warning', this.$t('Common.tips.noSelect'))
        return;
      }
      const $this = this;
      this.$layer.confirm({
        msg: $this.$t('MCS.deleteConfirm'),
        btn1: {
          msg: $this.$t('MCS.confirm'),
          func: () => {
            const returnIdx = () => {
              const result = [];
              $this.$refs.grid.getSelectedRecords().forEach((item) => {
                result.push(item.index);
              });
              return result;
            };
            const returnGpNums = () => {
              const result = [];
              $this.$refs.grid.getSelectedRecords().forEach((item) => {
                result.push(item.groupNum);
              });
              return result;
            };
            const info = {
              msgid: $this.msg.delGroupList,
              neid: $this.neid,
            };
            const groupNums = returnGpNums();
            const logArray = [];
            groupNums.forEach((gpItem) => {
              logArray.push({
                userNum: $this.mcsid,
                groupNum: gpItem
              });
            });
            const gpIdx = returnIdx();
            const vo = {
              opCount: this.$refs.grid.getSelectedRecords().length,
              index: gpIdx
            };
            const params = {
              info: info,
              vo: vo,
              log: {
                module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
                execFunName: 'subscriberMcs.mcsDelGroupList',
                exectype: 1,
                execData: logArray
              }
            };
            $this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
              const resObj = [];
              for (let i = 0; i < vo.opCount; i++) {
                resObj.push({
                  operObj: groupNums[i],
                  operResult: response.data.resultVal[i].display,
                  operCode: response.data.resultVal[i].code
                });
              }
              $this.$refs.dialog.addOperetionResultList(resObj);
              $this.$refs.dialog.setTotalCount(vo.opCount);
              $this.$refs.dialogPage.show();
              $this.getGroupList();
            });
          }
        },
        btn2: {
          msg: this.$t('MCS.cancle')
        }
      });
    },
    closeDialogListTipPage() {
      this.$refs.dialogPage.clear();
      this.$refs.dialogPage.close();
    }
  },
};
</script>

<style scoped>

</style>
